import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import {
  convertBefehl6FormDataToModel,
  convertModelToBefehl6FormData
} from './converters'
import { useBefehlForm } from '../../../hooks'
import { Befehl6 } from '../../../models'
import { Befehl6FormData, createBefehl6FormValidationSchema } from './schema'
import { BefehlFormProps, BefehlFormWrapper } from '../Generic'
import { AuftragX_95Form } from '../Auftraege'
import { Auftrag6_40Form } from './Auftrag6_40Form'
import { Auftrag6_90Form } from './Auftrag6_90Form'

export function Befehl6Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-6-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl6>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl6FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl6FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl6FormData(befehl) : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl6FormData) => {
      const updatedBefehl = convertBefehl6FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl6FormData>
      befehlKennung="6"
      title={t('befehle.6.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      displayHeaderOnly={displayHeaderOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
    >
      <Auftrag6_40Form
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-6-40`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />

      <Auftrag6_90Form
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-6-90`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />

      <AuftragX_95Form
        befehlKennung="6"
        fieldNamePrefix="auftrag_6_95"
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-6-95`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
        withGrundTabelle
      />
    </BefehlFormWrapper>
  )
}
